import StyledProductCardSkeleton, {
  StyledCategory,
  StyledPrice,
  StyledSize,
  StyledTitle,
} from './styles';
import {ProductCardSkeletonProps} from './typings';

const ProductCardSkeleton = ({aspectRatio, announce = false}: ProductCardSkeletonProps) => {
  return (
    <StyledProductCardSkeleton
      $aspectRatio={aspectRatio}
      role={announce ? 'status' : undefined}
      aria-label={announce ? 'Loading product card...' : undefined}
      aria-busy={announce ? 'true' : undefined}
    >
      <figure></figure>
      <section>
        <StyledTitle></StyledTitle>
        <StyledCategory></StyledCategory>
        <StyledSize></StyledSize>
        <StyledPrice></StyledPrice>
      </section>
    </StyledProductCardSkeleton>
  );
};

export default ProductCardSkeleton;
